import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/landing/Logo";
import { CONTACT_EMAIL, CONTACT_MAILTO } from "@/lib/contact";
import { EASE } from "@/lib/motion";

export default function LegalPage({ kind, sections }) {
  const isTerms = kind === "terms";
  return (
    <div data-testid={`${kind}-page`} className="relative min-h-screen">
      <div className="grain" />

      <header className="border-b border-black/10">
        <div className="mx-auto flex h-20 max-w-[1200px] items-center justify-between px-6 md:px-12">
          <Link to="/" className="flex items-center gap-3">
            <Logo size={40} />
            <span className="font-serif text-xl font-semibold tracking-tight text-[#2A2724]">
              Book Away
            </span>
          </Link>
          <Link
            to="/"
            className="group inline-flex items-center gap-2 rounded-full border border-black/15 px-5 py-2 text-sm text-[#2A2724] transition-colors duration-300 hover:border-gold hover:text-gold"
          >
            <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
            Back
          </Link>
        </div>
      </header>

      <motion.article
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
        className="relative z-10 mx-auto max-w-3xl px-6 py-20 md:px-12 md:py-28"
      >
        <p className="overline mb-6">Legal</p>
        <h1 className="font-serif text-5xl md:text-6xl font-light leading-[1.02] tracking-tight text-[#2A2724]">
          {isTerms ? "Terms of Service" : "Privacy Policy"}
        </h1>
        <p className="mt-4 text-sm text-[#6B6B6B]">Last updated: December 2025</p>

        <div className="mt-12 space-y-10 text-[#3a3a3a] leading-relaxed">
          {sections.map((s) => (
            <section key={s.title}>
              <h2 className="font-serif text-2xl md:text-3xl font-semibold text-[#2A2724]">
                {s.title}
              </h2>
              <div className="mt-3 space-y-4 text-[15px]">
                {s.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </section>
          ))}

          <section>
            <h2 className="font-serif text-2xl md:text-3xl font-semibold text-[#2A2724]">
              Contact us
            </h2>
            <p className="mt-3 text-[15px]">
              For any {isTerms ? "legal" : "privacy"} inquiries, requests, or notices,
              please write to{" "}
              <a
                data-testid="legal-contact-email"
                href={CONTACT_MAILTO}
                className="font-medium text-gold underline decoration-gold/50 underline-offset-4 hover:decoration-gold"
              >
                {CONTACT_EMAIL}
              </a>
              . We aim to respond within five business days.
            </p>
          </section>
        </div>
      </motion.article>
    </div>
  );
}
